import { Range } from "../Range/Range";

interface Props<T> {
  datapoints: T[];
  value: T;
  setValue: (value: T) => void;
  title?: string;
  tooltip?: string;
  leftLabel?: string;
  rightLabel?: string;
  isDisabled?: boolean;
}

export const RangeDatapoints = <T,>({
  datapoints,
  value,
  setValue,
  title,
  tooltip,
  leftLabel,
  rightLabel,
  isDisabled,
}: Props<T>) => {
  return (
    <Range
      min={0}
      max={datapoints.length - 1}
      step={1}
      value={datapoints.findIndex((datapoint) => datapoint === value)}
      valueLabel={String(value)}
      setValue={(valueInner) => {
        setValue(datapoints[valueInner]);
      }}
      title={title}
      tooltip={tooltip}
      leftLabel={leftLabel}
      rightLabel={rightLabel}
      isDisabled={isDisabled}
    />
  );
};
